import { Body2, UIHeading5, Image } from '@cian/ui-kit';
import {
  IconActionArrowShapeTurnUpLeft16,
  IconActionClose16,
  IconFileDocument16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import type { TThumbnail } from '../../types/thumbnail';

import styles from './ReplyPreview.css';

type TReplyPreviewProps = {
  authorName: string;
  text: string;
  thumbnail: TThumbnail;
  onClose: VoidFunction;
  onQuoteClick: VoidFunction;
};

export const ReplyPreview: React.FC<TReplyPreviewProps> = ({ authorName, text, thumbnail, onClose, onQuoteClick }) => {
  const handleQuoteKeyDown = React.useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onQuoteClick();
      }
    },
    [onQuoteClick],
  );

  return (
    <div className={styles['container']} data-name="ReplyPreview">
      <div className={styles['icon-wrapper']}>
        <IconActionArrowShapeTurnUpLeft16 color="icon-main-default" />
      </div>
      <div className={styles['quote']} onClick={onQuoteClick} role="button" tabIndex={0} onKeyDown={handleQuoteKeyDown}>
        <div className={styles['border']} />

        {thumbnail?.type === 'image' && (
          <Image
            src={thumbnail.url}
            width={32}
            height={32}
            objectFit="cover"
            borderRadius="4px"
            preloader={false}
            alt=""
          />
        )}

        {thumbnail?.type === 'document' && (
          <div className={styles['doc-icon']}>
            <IconFileDocument16 color="icon-main-default" />
          </div>
        )}

        <div className={styles['text']}>
          <UIHeading5 color="text-main-default" fontWeight="700" ellipsis>
            В ответ {authorName && `· ${authorName}`}
          </UIHeading5>
          <Body2 color="text-primary-default" ellipsis>
            {text}
          </Body2>
        </div>
      </div>
      <button className={styles['close-button']} onClick={onClose} type="button" data-testid="ReplyPreviewCloseButton">
        <IconActionClose16 color="icon-secondary-default" />
      </button>
    </div>
  );
};
